import { SVGProps } from "react"

const UserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.0013 7.16667C8.30772 7.16667 8.61114 7.10631 8.89423 6.98905C9.17732 6.87179 9.43455 6.69992 9.65122 6.48325C9.86789 6.26658 10.0398 6.00935 10.157 5.72626C10.2743 5.44317 10.3346 5.13975 10.3346 4.83333C10.3346 4.52692 10.2743 4.2235 10.157 3.94041C10.0398 3.65731 9.86789 3.40009 9.65122 3.18342C9.43455 2.96675 9.17732 2.79488 8.89423 2.67761C8.61114 2.56035 8.30772 2.5 8.0013 2.5C7.38246 2.5 6.78897 2.74583 6.35139 3.18342C5.9138 3.621 5.66797 4.21449 5.66797 4.83333C5.66797 5.45217 5.9138 6.04566 6.35139 6.48325C6.78897 6.92083 7.38246 7.16667 8.0013 7.16667V7.16667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 14.0999V14.4999H14V14.0999C14 12.6066 14 11.8599 13.7093 11.2893C13.4537 10.7875 13.0457 10.3796 12.544 10.1239C11.9733 9.83325 11.2267 9.83325 9.73333 9.83325H6.26667C4.77333 9.83325 4.02667 9.83325 3.456 10.1239C2.95426 10.3796 2.54633 10.7875 2.29067 11.2893C2 11.8599 2 12.6066 2 14.0999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default UserIcon
